var map = {
	"./gogo.dark.blue.scss": [
		85,
		20
	],
	"./gogo.dark.green.scss": [
		86,
		21
	],
	"./gogo.dark.orange.scss": [
		87,
		22
	],
	"./gogo.dark.purple.scss": [
		88,
		23
	],
	"./gogo.dark.red.scss": [
		89,
		24
	],
	"./gogo.light.blue.scss": [
		90,
		25
	],
	"./gogo.light.green.scss": [
		91,
		26
	],
	"./gogo.light.orange.scss": [
		92,
		27
	],
	"./gogo.light.purple.scss": [
		93,
		28
	],
	"./gogo.light.red.scss": [
		94,
		29
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 52;
module.exports = webpackAsyncContext;